import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "./index.scss";
import { LogoIcon } from "../../assets/icons/LogoIcon";
import { LogoSimpleIcon } from "../../assets/icons/LogoSimpleIcon";
import { useNavigate } from "react-router-dom";
import { login } from "../../service/simulation.service";

const RegisterForm = () => {
  const [loading, setloading] = useState(false);
  const [errors, setErrors] = useState({ hasError: false, msg: "" });
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  // const { t } = useTranslation();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    setErrors({ hasError: false, msg: "" });

    if (!formData.email || !formData.password) {
      setErrors({
        hasError: true,
        msg: "L'email et le mot de passe sont requis!",
      });
      setloading(false);
      return;
    }

    const res = await login(formData.email, formData.password);
    console.log("res", res);
    if (res.success) {
      setloading(false);

      setTimeout(() => {
        const token = res.userData.accessToken;
        // Encodage URL par sécurité
        window.location.href = `https://gestiondevis.msit-demo.fr/users?token=${encodeURIComponent(
          token
        )}&refreshToken=${encodeURIComponent(res.userData.refreshToken)}`;
      }, 1000);
    } else {
      setErrors({
        hasError: true,
        msg: res.msg,
      });
      setloading(false);
    }
  };
  return (
    <div className="register-page">
      <div className="register-box">
        <div className="row d-flex align-items-center justify-content-center w-100">
          <div className="col-md-2 mt-3">
            <LogoIcon />
          </div>
          <div className="col-md-10"></div>
        </div>

        <div className="form-con">
          <LogoSimpleIcon />
          <h2 className="text-center mt-4">Connexion</h2>
          <p className="text-center mb-5">
            Connectez-vous pour
            <br /> retrouver vos projets
          </p>

          <Form className="form-fields">
            <Form.Control
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              className="mb-3"
              value={formData.email}
              onChange={handleChange}
            />
            <Form.Control
              type="password"
              name="password"
              id="password"
              placeholder="Mot de passe"
              className="mb-3"
              value={formData.password}
              onChange={handleChange}
            />

            <Button
              className="create-btn  w-100"
              type="submit"
              onClick={handleSubmit}
            >
              {loading ? "Connexion..." : "Connexion"}
            </Button>
          </Form>

          <p className="footer-text">
            Vous n'avez pas de compte ?{" "}
            <a href="/demandez-devis" className="link-text">
              S'inscrire
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
